import { IconButton, Switch } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import { MobileViewCellDataGrid } from "components/MobileViewCellDataGrid/MobileViewCellDataGrid";

export const finishListColumnsS = (handleEdit, handleChangeStatus) => [
  { field: "id", headerName: "Id" },
  {
    field: "finishCode",
    headerName: "Finish Code",
    flex: 1,
    renderCell: (params) => (
      <>
        <MobileViewCellDataGrid
          tableData={[
            {
              label: "Finish Code",
              data: params.row.finishCode,
              action: "",
            },
            {
              label: "Description",
              data: params.row.finishDescription,
              action: "",
            },
            {
              label: "Is Approved",
              data: (
                <Switch
                  checked={params.row.isApproved}
                  onChange={() => {
                    handleChangeStatus(params.row.id, params.row.isApproved);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              ),
              action: "",
            },
            {
              label: "Edit",
              data: (
                <IconButton onClick={() => handleEdit(params.row)}>
                  <EditIcon />
                </IconButton>
              ),
              action: "",
            },
          ]}
        />
      </>
    ),
  },
];
